import { Observable } from 'rxjs';
import { apiClient } from '~admin/client';
import { MarketplaceResponse } from '~client/model/admin/marketplace-response';

/**
 * Enables a marketplace for a particular event
 * @param marketplaceId
 */
export const performEnableMarketplace = (marketplaceId: number): Observable<MarketplaceResponse> =>
  apiClient.marketplaceAdminController.enableMarketplace$(marketplaceId);



// WEBPACK FOOTER //
// ./interactor/marketplace/perform-enable-marketplace.ts